module.exports = "<div class=\"checkout-container\">\r\n    <h1 class=\"sr-only\">Checkout</h1>\r\n    <wow-checkout-header></wow-checkout-header>\r\n    <div ui-view=\"checkout-content\"></div>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/views/checkout.html
 ** module id = 1041
 ** module chunks = 1
 **/